export interface Currencies {
  code: string;
  name: string;
  symbol: string;
}

export const CURRENCIES: Currencies[] = [
  {
    code: 'USD',
    name: 'United States dollar',
    symbol: 'US$',
  },
  {
    code: 'EUR',
    name: 'Euro',
    symbol: '\u20ac',
  },
  {
    code: 'GBP',
    name: 'British pound',
    symbol: '\u00a3',
  },
  {
    code: 'YEN',
    name: 'Japanese yen',
    symbol: '\u00a5',
  },
  {
    code: 'CAD',
    name: 'Canadian dollar',
    symbol: 'CA$',
  },
  {
    code: 'AUD',
    name: 'Australian dollar',
    symbol: 'AU$',
  },
  {
    code: 'CNY',
    name: 'Chinese yuan',
    symbol: '\u00a5',
  },
  {
    code: 'CHF',
    name: 'Swiss franc',
    symbol: 'Fr',
  },
  {
    code: 'SGD',
    name: 'Singapore dollar',
    symbol: 'SG$',
  },
  {
    code: 'HKD',
    name: 'Hong Kong dollar',
    symbol: 'HK$',
  },
  {
    code: 'AED',
    name: 'United Arab Emirates dirham',
    symbol: '\u062f.',
  },
  {
    code: 'SAR',
    name: 'Saudi riyal',
    symbol: '\u0631.\u0633',
  },
  {
    code: 'TRY',
    name: 'Turkish lira',
    symbol: 'TRY',
  },
  {
    code: 'BRL',
    name: 'Brazilian real',
    symbol: 'R$',
  },
  {
    code: 'ISK',
    name: 'Icelandic kr\u00f3na',
    symbol: 'kr',
  },
  {
    code: 'NZD',
    name: 'New Zealand dollar',
    symbol: 'NZ$',
  },
  {
    code: 'ARS',
    name: 'Argentine peso',
    symbol: 'AR$',
  },
  {
    code: 'COP',
    name: 'Colombian peso',
    symbol: 'CO$',
  },
  {
    code: 'CZK',
    name: 'Czech koruna',
    symbol: 'K\u010d',
  },
  {
    code: 'DKK',
    name: 'Danish krone',
    symbol: 'kr',
  },
  {
    code: 'DZD',
    name: 'Algerian dinar',
    symbol: '\u062f.\u062c',
  },
  {
    code: 'EGP',
    name: 'Egyptian pound',
    symbol: 'GB\u00a3',
  },
  {
    code: 'HUF',
    name: 'Hungarian forint',
    symbol: 'Ft',
  },
  {
    code: 'INR',
    name: 'Indian rupee',
    symbol: '\u20b9',
  },
  {
    code: 'KRW',
    name: 'South Korean won',
    symbol: '\u20a9',
  },
  {
    code: 'KWD',
    name: 'Kuwaiti dinar',
    symbol: '\u062f.\u0643',
  },
  {
    code: 'MAD',
    name: 'Moroccan dirham',
    symbol: '\u062f.\u0645.',
  },
  {
    code: 'MUR',
    name: 'Mauritian rupee',
    symbol: '\u20a8',
  },
  {
    code: 'MXN',
    name: 'Mexican peso',
    symbol: 'MX$',
  },
  {
    code: 'MYR',
    name: 'Malaysian ringgit',
    symbol: 'RM',
  },
  {
    code: 'NOK',
    name: 'Norwegian krone',
    symbol: 'kr',
  },
  {
    code: 'PKR',
    name: 'Pakistani rupee',
    symbol: '\u20a8',
  },
  {
    code: 'PLN',
    name: 'Polish z\u0142oty',
    symbol: 'z\u0142',
  },
  {
    code: 'QAR',
    name: 'Qatari riyal',
    symbol: '\u0631.\u0642',
  },
  {
    code: 'RUB',
    name: 'Russian ruble',
    symbol: '\u20bd',
  },
  {
    code: 'SEK',
    name: 'Swedish krona',
    symbol: 'kr',
  },
  {
    code: 'THB',
    name: 'Thai baht',
    symbol: '\u0e3f',
  },
  {
    code: 'TND',
    name: 'Tunisian dinar',
    symbol: '\u062f.\u062a',
  },
  {
    code: 'ZAR',
    name: 'South African rand',
    symbol: 'R',
  },
];
